export const COLUMNS = [
    {
        Header:'PRODUCT',
        accessor:'Product'
    },
    {
        Header:'CATEGORY',
        accessor:'Category'
    }
]